import { INSURANCE, TAKAFUL } from '@/constants';
import {
  EntityTypeId,
  EntityTypeKey,
  ProductCode,
  ProductId,
} from '@/enums';
import { PaApiPath } from '@/enums/enum/PaApiPath';

export const getProductId = (entity: string) => {
  return entity === INSURANCE
    ? ProductId.Oto360Insurance
    : ProductId.Oto360Takaful;
};

export const getProductCode = (entity: string) => {
  return entity === INSURANCE
    ? ProductCode.Oto360Insurance
    : ProductCode.Oto360Takaful
};

export const getProductName = (entity: string) => {
  return entity === INSURANCE
    ? 'OTO360 Insurance'
    : 'OTO360 Takaful'
};

export const getEntityTypeId = (param: string) => {
  switch (param) {
    case INSURANCE:
      return EntityTypeId.EGIB;
    case TAKAFUL:
      return EntityTypeId.EGTB;
    default:
      return 0;
  }
};

export const getEntityTypeKey = (param: string) => {
  switch (param) {
    case INSURANCE:
      return EntityTypeKey.EGIB;
    case TAKAFUL:
      return EntityTypeKey.EGTB;
    default:
      return '';
  }
};

export const getAPIPath = () => {
  return PaApiPath.Oto360;
};
